export default "__VITE_ASSET__DhptSgXJ__"